import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { ApiError, api } from "../../api";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { Input } from "../ui/input";

export function CreatePreviewDialog() {
  const [open, setOpen] = useState(false);
  const [prUrl, setPrUrl] = useState("");
  const queryClient = useQueryClient();
  const create = useMutation({
    mutationFn: () => api.createPreview({ prUrl: prUrl.trim() }),
    onSuccess: () => {
      toast.success("Preview requested");
      setOpen(false);
      setPrUrl("");
      void queryClient.invalidateQueries({ queryKey: ["previews"] });
    },
    onError: (error) => toast.error(error instanceof ApiError ? error.message : "Could not create preview"),
  });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>
          <Plus /> New preview
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Preview a pull request</DialogTitle>
          <DialogDescription>
            Builds a seeded copy of the monorepo at the pull request's head. It expires after 3 days. Forks
            are refused.
          </DialogDescription>
        </DialogHeader>
        <Input
          value={prUrl}
          onChange={(event) => setPrUrl(event.target.value)}
          placeholder="https://github.com/leaselab/monorepo/pull/123"
        />
        <DialogFooter>
          <Button disabled={!prUrl.trim() || create.isPending} onClick={() => create.mutate()}>
            Create preview
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
